import { Checkbox } from '@billda/design-system';

export interface TableCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  indeterminate?: boolean;
}

/**
 * Standardized checkbox component for table rows.
 * Always renders small for consistent appearance.
 */
export function TableCheckbox({
  checked,
  onChange,
  disabled,
  indeterminate,
}: TableCheckboxProps) {
  return (
    <Checkbox
      checked={indeterminate ? 'indeterminate' : (checked ?? false)}
      onCheckedChange={value => {
        onChange?.(value === true);
      }}
      disabled={disabled}
      aria-checked={indeterminate ? 'mixed' : undefined}
    />
  );
}
